var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    viewBox: "280.95 335.22 50.09 86.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.39,344.95c-0.64-0.1-1.27-0.18-2.35-0.18c-3.8,0-5.37,1.81-5.37,5.11c0,2.63,0.93,6.98,3.9,12.91   c-1.19,0.14-2.47,0.33-3.78,0.55c-2.72-5.27-3.82-9.39-3.99-12.75c-3.41,0.16-4.9,1.77-4.9,4.37c0,2.21,1.63,5.88,4.4,9.28   c-2.88,0.65-5.78,1.45-8.35,2.34v8.23c3.54-1.85,8.55-2.97,12.89-2.97c4.82,0,8.68,0.99,12.17,2.48l0.01-39.1   c-2.83,0-4.62,1.31-4.62,1.31L301.39,344.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.82,344.76c-1.09,0-1.72,0.09-2.36,0.19l0.01,17.58c1.13,0.03,2.42,0.13,3.82,0.29   c2.99-5.95,3.91-10.3,3.91-12.94C318.19,346.57,316.62,344.76,312.82,344.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.07,350.59c-0.17,3.37-1.28,7.51-4.02,12.8c1.46,0.25,2.97,0.54,4.49,0.87c2.79-3.4,4.43-7.09,4.43-9.31   C326.97,352.36,325.48,350.75,322.07,350.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.01,397.89v7.53c-3.99-1.88-7.97-2.89-12.28-2.89c-3.49,0-8.02,0.84-11.12,2.21   c3.88,8.98,13.92,14.45,23.4,16.89c11.75-3.03,24.35-10.7,25.03-23.92c-3.1,1.62-8.14,2.96-12.83,2.96   C313.69,400.68,309.78,399.67,306.01,397.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.79,393.34h3.95v-14.78h-4.05v6.92c0,0.27,0.01,0.6,0.03,0.92c-0.18-0.37-0.38-0.75-0.57-1.07l-4.02-6.78   h-3.97v14.78h4.05v-6.9c0-0.27-0.01-0.6-0.03-0.92c0.18,0.36,0.38,0.75,0.57,1.07L289.79,393.34z M296.7,393.34h4.05v-14.78h-4.05   V393.34z M314,385.86c0,2.22-1.56,3.96-3.55,3.96c-1.99,0-3.54-1.74-3.54-3.96c0-2.12,1.56-3.78,3.54-3.78   C312.44,382.07,314,383.73,314,385.86 M318.17,385.86c0-4.3-3.32-7.54-7.72-7.54c-4.4,0-7.72,3.24-7.72,7.54   c0,4.4,3.32,7.72,7.72,7.72C314.86,393.57,318.17,390.25,318.17,385.86 M324.94,389.78c-0.15,0-0.28,0-0.41,0.01   c0.18-0.21,0.4-0.48,0.64-0.82l5.5-7.81l0.05-0.07v-2.52h-11.3v3.56h5.51c0.15,0,0.28,0,0.41-0.01c-0.18,0.21-0.4,0.48-0.64,0.82   l-5.54,7.84v2.57h11.66v-3.56H324.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.cdc327f165058169ef38e77da2adbfa3.svg";
export { ForwardRef as ReactComponent };